// extracted by mini-css-extract-plugin
export default {"section":"TechnologiesSection_section__Az3mf"};